<div class="flex-align-center gap-XS pad-left-S pad-right-M horizontal-bar-L"
     [class]="'color-' + color">
    <img src="assets/icons/health-2.svg" width="16" height="16" alt=""/>
    <span class="font-M fw-500">{{!health ? '-' : ('page.dashboard.typology.' + health.status)|translate}}</span>
</div>
